import React from "react";
import { ContentSection } from "./ContentSection";
import ChangeRequestContext, {
  ChangeRequestProvider,
} from "src/context/ChangeRequestContext";
import { Detail } from "src/templates";
import { SnackbarSection } from "./SnackbarSection";
import { AlertBannerSection } from "./AlertBannerSection";
import { useChangeRequestEffects } from "./hooks/useChangeRequestEffects";
import { Loadable } from "src/components/Loading";
import { SidebarSection } from "./SidebarSection";
import { ChangeRequestContainerProps } from "./type";

export const ChangeRequestContainer = ({
  "data-id": dataId = "changeRequestDetail",
}: ChangeRequestContainerProps) => {
  const { formValues, isLoading } = useChangeRequestEffects();
  const { premiseAddress } = React.useContext(ChangeRequestContext);
  return (
    <Loadable isLoading={isLoading}>
      <Detail
        pageTitleSection={"Change energy supply"}
        addressSection={premiseAddress}
        sidebarSection={<SidebarSection />}
        alertBannerSection={<AlertBannerSection />}
        snackbarSection={<SnackbarSection />}
        data-id={dataId}
      >
        <ContentSection formValues={formValues} />
      </Detail>
    </Loadable>
  );
};

export const ChangeRequest: React.FC = () => {
  return (
    <ChangeRequestProvider>
      <ChangeRequestContainer />
    </ChangeRequestProvider>
  );
};
